app.service('introHelperService', ['$state', '$filter', 'accountSM', function ($state, $filter, accountSM) {

    var that= this;
    this.introOptions = {};
    this.myIntroJs = introJs();
	this.currentTarget = null;
    this.onChangeTargetFunction = null;
    this.routeName = null;

    /**
     * bind des étapes en fonction de la route où l'on se trouve
     * @return {[type]} [description]
     */
    var bindSteps = function() {

        var steps = {
            default: [
                {
                    intro: $filter('capitalize')($filter('translate')('helper_aucune_aide')) // "Aucune aide pour cette page"
                }
            ],

            home: [
                {
                    element: '#btn-open-helper',
                    intro: $filter('capitalize')($filter('translate')('helper_bouton_ouverture_aide')), // "Vous pouvez à tous moment consulter l'aide d'utilisation",
                    position: 'left'
                },
                {
                    element: '#btn-open-filter',
                    intro: $filter('capitalize')($filter('translate')('helper_bouton_ouverture_filtre')), // "Ce bouton vous permet d'afficher la fenêtre des filtres",
                    position: 'left'
                },
                {
                    intro: $filter('capitalize')($filter('translate')('helper_fenetre_filtre')), // "Voici la fenêtre des filtres"
                },
                {
                    element: '#arbo-container', // '.sites_tree_list',
                    intro: $filter('capitalize')($filter('translate')('helper_arbo_liste')), // "Vous y trouvez ici votre patrimoine",
                    position: 'top'
                },
                {
                    element: '.btn-show-list',
                    intro: $filter('capitalize')($filter('translate')('helper_voir_arbo_en_liste')), // "Ce bouton permet de voir votre patrimoine sous forme de liste",
                    position: 'right'
                },
                {
                    element: '.tree-search-input',
                    intro: $filter('capitalize')($filter('translate')('helper_recherche_arbo')), // "Il est possible d'effectuer une recherche sur un site ou groupement de site ici",
                    position: 'right'
                },
                {
                    element : '#show-only-selected',
                    intro: $filter('capitalize')($filter('translate')('helper_voir_only_site_checked')), // "Ce bouton vous permet de voir les sites que vous avez selectionné",
                    position: 'right'
                },
                {
                    element : '#expand-all-nodes',
                    intro: $filter('capitalize')($filter('translate')('helper_etendre_arbo')), // "Ce bouton vous permet d'étendre votre patrimoine",
                    position: 'right'
                },
                {
                    element : '#expand-tree-container',
                    intro: $filter('capitalize')($filter('translate')('helper_etendre_fenetre_patrimoine')), // "Ce bouton vous permet d'étendre la fenêtre",
                    position: 'left'
                },
                {
                    element: '#show-nodes-map',
                    intro: $filter('capitalize')($filter('translate')('helper_voir_arbo_en_carte')), // "Vous pouvez aussi voir votre patrimoine sur une carte",
                    position: 'right'
                },
                {
                    intro: $filter('capitalize')($filter('translate')('helper_arbo_carte')), // "Voici votre patrimoine sous forme de carte, vous pouvez cliquer sur les marqueurs pour avoir plus de détails",
                },
                {
                    element: '#btn-apply-filter',
                    intro: $filter('capitalize')($filter('translate')('helper_bouton_appliquer_filtres')), // "Après avoir sélectionné les sites que vous souhaitez filtrer, veuillez cliquer sur ce bouton pour appliquer",
                    position: 'left'
                },
                {
                    element: '#btn-close-filter',
                    intro: $filter('capitalize')($filter('translate')('helper_bouton_fermer_filtres')), // "Sinon, cliquer sur celui là pour fermer la fenêtre",
                    position: 'left'
                },
                {
                    element : '#logo-menu',
                    intro : $filter('capitalize')($filter('translate')('helper_menu_logo')), // "Cliquer sur le logo pour retourner à l'accueil",
                    position: 'right'
                },
                {
                    element : '#local-dropdown-menu',
                    intro : $filter('capitalize')($filter('translate')('helper_change_local')), // "Vous pouvez changer la langue de l'application",
                    position: 'right'
                },
                {
                    element : '#expand-btn-menu',
                    intro : $filter('capitalize')($filter('translate')('helper_menu_etendre')), // "Il est possible d'étendre ou non le menu",
                    position: 'right'
                },
                {
                    element : '#main-container', /* '#contrats-cards', */
                    intro : $filter('capitalize')($filter('translate')('helper_cartes_contrats')), // "Voici les contrats disponibles pour votre compte",
                    position: 'left'
                },{
                    element : '.kpi-contrat',
                    intro : $filter('capitalize')($filter('translate')('helper_kpi_contrat')), // "Cela correspond à la progression de vos contrats celons les filtres que vous avez appliquez",
                    position: 'bottom'
                }
            ],

            uiGrid: [
                {
                    element: '.ui-search-input',
                    intro: $filter('capitalize')($filter('translate')('helper_ui_grid_recherche')),
                    position: 'right'
                }, {
                    element: '.full-screen-btn',
                    intro: $filter('capitalize')($filter('translate')('helper_ui_grid_bouton_full_screen')),
                    position: 'left'
                }, {
                    element: '.ui-btn-settings',
                    intro: $filter('capitalize')($filter('translate')('helper_ui_grid_bouton_param')),
                    position: 'left'
                }, {
                    element: '.ui-exports',
                    intro: $filter('capitalize')($filter('translate')('helper_ui_grid_bouton_exports')),
                    position: 'left'
                }
            ],

            contrat: function() {
                var stepsContrat = [];
                if($('.ui-grid')[0]) stepsContrat = stepsContrat.concat(steps.uiGrid); // Si une UI-GRID existe sur la page, on ajoute les étapes pour UI-GRID
                if(stepsContrat.length < 1) stepsContrat = steps.default;
                return stepsContrat;
            }

        };


        switch(that.routeName) {
            case 'app.home':
                // Si Accueil
                that.introOptions.steps = steps.home;
                break;
			default:
                if($state.includes('app.contrat')) that.introOptions.steps = steps.contrat();
                else that.introOptions.steps = steps.default;
        }
    };



    /**
     * Au changement d'étape sur la page d'accueil
     * @param  {[type]} oldTarget     [description]
     * @param  currentTarget
     * @return boolean
     */
    var onChangeTargetHome = function(oldTarget, currentTarget) {
		var oldTargetEltId = $(oldTarget).attr('id');
		var currentTargetEltId = $(currentTarget).attr('id');

        if(currentTargetEltId == "logo-menu" && that.myIntroJs._currentStep !== 0) $('.introjs-button.introjs-prevbutton').hide();
        else $('.introjs-button.introjs-prevbutton').show();

        if(oldTargetEltId == "btn-open-filter" && angular.isUndefined(currentTargetEltId)) {
            // Ouverture de la bottom filter
			$('#btn-open-filter').click();
			return true;
		}
		if(angular.isUndefined(oldTargetEltId) && that.myIntroJs._currentStep == 3) {
            // Apres ouverture de la bottom filter, relancer myIntroJs pour prendre en compte les elements qui n'étaient pas visibles
			that.myIntroJs.exit();
			that.exec(4);
			return true;
		}

		if(currentTargetEltId == 'show-only-selected') {
			$('#show-only-selected').click();
			return true;
		}
		if(currentTargetEltId == 'show-nodes-map') {
			$('#show-nodes-map').click();
			return true;
		}
		if(currentTargetEltId == 'btn-apply-filter') {
			$('#show-nodes-list').click();
			return true;
		}
		if(oldTargetEltId == 'btn-close-filter') {
			$('#btn-close-filter').click();
			return true;
		}
		if(oldTargetEltId == "btn-apply-filter" && angular.isUndefined(currentTargetEltId)) {
            // Précedent apres affichage map : re-affichage de la google map
			$('#show-nodes-map').click();
			return true;
		}
		if(angular.isUndefined(oldTargetEltId) && currentTargetEltId == "btn-open-filter") {
            // Précedent apres ouverture du bottom filter : fermeture bottom filter
			$('#btn-close-filter').click();
			return true;
		}
		if(oldTargetEltId == 'expand-btn-menu' /* && currentTargetEltId == "local-dropdown-menu" */) {
			$('#expand-btn-menu').click();
			return true;
		}
        // if(currentTargetEltId == "expand-btn-menu") {
        //     $('#expand-btn-menu').click();
        //     return true;
        // }
		if(oldTargetEltId == "expand-tree-container" && currentTargetEltId == "expand-all-nodes") {
			$('#show-nodes-list').click();
			return true;
		}

    };


    /**
     * Au changement d'étape sur les pages des contrats
     * @param  {[type]} oldTarget     [description]
     * @param  {[type]} currentTarget [description]
     * @return {[type]}               [description]
     */
    var onChangeTargetContrat = function(oldTarget, currentTarget) {
        var oldTargetEltId = $(oldTarget).attr('id');
		var currentTargetEltId = $(currentTarget).attr('id');
        var oldTargetEltClasses = $(oldTarget).attr('class');
		var currentTargetEltClasses = $(currentTarget).attr('class');


        if(currentTargetEltClasses.indexOf('ui-btn-settings') != -1) currentTarget.click();
    };

    var onFinish = function() {
        if(that.routeName == 'app.home') accountSM.setFirstUse(0);
    };


    /**
     * Load introHelper
     * @return {[type]} [description]
     */
    this.load = function() {

        that.introOptions = {
    		steps:[],
    		showStepNumbers: false,
    		showBullets: false,
    		exitOnOverlayClick: false,
    		exitOnEsc:true,
    		nextLabel: '<strong>'+$filter('capitalize')($filter('translate')('suivant'))+'</strong>',
    		prevLabel: '<strong>'+$filter('capitalize')($filter('translate')('precedent'))+'</strong>',
    		skipLabel: $filter('capitalize')($filter('translate')('fermer')),
    		doneLabel: $filter('capitalize')($filter('translate')('fin'))
    	};

        that.routeName = $state.current.name;
        bindSteps();    // bind des étapes
        that.exec();    // excecution
    };

    /**
     * Exec introHelper
     * @param  {[type]} step [description]
     * @return {[type]}      [description]
     */
    this.exec = function(step) {
        that.currentTarget = null;
        that.myIntroJs = introJs();
		that.myIntroJs
    		.setOptions(that.introOptions)
    		.onchange(function(targetElement) {
                if(that.routeName == 'app.home') onChangeTargetHome(that.currentTarget, targetElement);
                else if(that.routeName.indexOf('app.contrat') === 0) onChangeTargetContrat(that.currentTarget, targetElement);
    			that.currentTarget = targetElement;
    		})
            .oncomplete(onFinish).onexit(onFinish).start();

        if(angular.isDefined(step)) that.myIntroJs.goToStep(step);
    };

}]);
